<template>
  <div class="login1" v-if="this.$route.query.employeeCode">加载中...</div>
  <div
    class="login"
    :style="{
      backgroundImage:
        'url(' + require('../../assets/images/login_jieyang.png') + ')',
    }"
    v-else
  >
    <div class="login-con">
      <div class="pag-cont">
        <div class="item-input" v-show="offType == 1">
          <div v-if="pwdUser.userMore">
            <div class="user-list">
              <div
                class="user-item"
                @click="selectItem(item)"
                :class="pwdUser.item.id == item.id ? 'user-item-active' : ''"
                v-for="(item, index) in pwdUser.list"
                :key="index"
              >
                <div style="flex: 1">
                  <img
                    :src="item.portraitUrl ? item.portraitUrl : imgLogo"
                    alt=""
                  />
                  <span>{{ item.tenantName }}</span>
                </div>
              </div>
              <img
                title="关闭"
                @click="closePwdUser"
                src="@/assets/images/close.png"
                alt=""
                class="close"
              />
            </div>
            <div class="login-btn" @click="loginTenant" v-preventReClick>
              登录
            </div>
          </div>
          <div v-else>
            <div
              style="
                color: rgb(87 80 80);
                text-align: center;
                margin-bottom: 8rem;
                font-weight: 600;
                font-size: 2.5rem;
                letter-spacing: 5rem;
                padding-left: 5rem;
              "
            ></div>
            <Form ref="formPwd" :model="formPwd" :rules="rulePwd">
              <FormItem prop="username">
                <Tooltip
                  content="大写锁定已打开"
                  placement="top"
                  trigger="focus"
                  :transfer="true"
                  :disabled="isCapsLock"
                >
                  <Input
                    class="input-f"
                    @keyup.enter.native="loginSubmit($event, 'formPwd')"
                    v-model="formPwd.username"
                    placeholder="请输入账号名"
                    @on-keydown="onCapsLock($event, 'user')"
                    @on-focus="onFocus($event)"
                  />
                </Tooltip>
              </FormItem>
              <FormItem prop="password">
                <Tooltip
                  content="大写锁定已打开"
                  placement="top"
                  :transfer="true"
                  :disabled="isCapsLock"
                >
                  <Input
                    class="input-f"
                    @keyup.enter.native="loginSubmit($event, 'formPwd')"
                    type="password"
                    v-model="formPwd.password"
                    placeholder="请输入密码"
                    @on-keyup="onCapsLock($event, 'pass')"
                  />
                </Tooltip>
              </FormItem>
              <FormItem prop="authCode" v-if="istrue">
                <!-- 大三大四 -->
                <div class="input-code">
                  <Input
                    class="input-f"
                    @keyup.enter.native="loginSubmit($event, 'formPwd')"
                    v-model="formPwd.smsCode"
                    placeholder="请输入短信验证码"
                  />
                  <div class="right-icon">
                    <span class="code-span" v-if="formPwd.offCode"
                      >{{ formPwd.time }}s</span
                    >
                    <span class="code-span" v-else @click="getCodes"
                      >发送验证码</span
                    >
                  </div>
                </div>
              </FormItem>
            </Form>

            <div class="login-btn" @click="loginGo('formPwd')" v-preventReClick>
              登录
            </div>

            <div class="pas-mi">
              <!-- <span style="color: rgb(87 80 80); cursor:pointer; font-weight: 600;" @click="goForgetPsd" v-if="!isPassWord">忘记密码?</span> -->
              <span
                style="color: rgb(87 80 80); cursor: pointer; font-weight: 600"
                @click="confirmA"
                v-if="isPassWord"
                >修改密码</span
              >
            </div>
          </div>
        </div>
        <div class="item-input" v-show="offType == 2">
          <div v-if="user.userMore">
            <div class="user-list">
              <div
                class="user-item"
                @click="selectItem(item)"
                :class="user.item.id == item.id ? 'user-item-active' : ''"
                v-for="(item, index) in this.user.list"
                :key="index"
              >
                <div style="flex: 1">
                  <img
                    :src="item.portraitUrl ? item.portraitUrl : imgLogo"
                    alt=""
                  />
                  <span>{{ item.tenantName }}</span>
                </div>
                <!-- <span>{{item.orgName}}</span> -->
              </div>
              <img
                title="关闭"
                @click="closeUser"
                src="@/assets/images/close.png"
                alt=""
                class="close"
              />
            </div>
            <div class="login-btn" @click="loginTenant" v-preventReClick>
              登录
            </div>
          </div>

          <div v-else>
            <Form ref="formPhone" :model="formPhone" :rules="rulePhone">
              <FormItem prop="mobile">
                <Input
                  class="input-f"
                  @keyup.enter.native="loginSubmit($event, 'formPhone')"
                  v-model="formPhone.mobile"
                  placeholder="请输入手机号"
                />
              </FormItem>
              <FormItem prop="authCode">
                <!-- 大三大四 -->
                <div class="input-code">
                  <Input
                    class="input-f"
                    @keyup.enter.native="loginSubmit($event, 'formPhone')"
                    v-model="formPhone.authCode"
                    placeholder="请输入短信验证码"
                  />
                  <div class="right-icon">
                    <span class="code-span" v-if="formPhone.offCode"
                      >{{ formPhone.time }}s</span
                    >
                    <span class="code-span" v-else @click="getCode"
                      >发送验证码</span
                    >
                  </div>
                </div>
              </FormItem>
            </Form>
            <div class="pas-mi">
              <!-- <Checkbox v-model="formPhone.single">记住密码</Checkbox> -->
              <!-- <a href="#">忘记密码?</a> -->
            </div>
            <div
              class="login-btn"
              @click="loginPhone('formPhone')"
              v-preventReClick
            >
              登录
            </div>
          </div>
          <div class="go-tentent" @click="goTenant">
            <span>还没有企业？</span><span>去注册</span>
          </div>
        </div>
        <div></div>
        <div class="item-input" v-show="offType == 3 && smUser.userMore">
          <div>
            <div class="user-list">
              <div
                class="user-item"
                @click="selectItem(item)"
                :class="smUser.item.id == item.id ? 'user-item-active' : ''"
                v-for="(item, index) in this.smUser.list"
                :key="index"
              >
                <div style="flex: 1">
                  <img
                    :src="item.portraitUrl ? item.portraitUrl : imgLogo"
                    alt=""
                  />
                  <span>{{ item.tenantName }}</span>
                </div>
                <!-- <span>{{item.orgName}}</span> -->
              </div>
              <img
                title="关闭"
                @click="closeSm"
                src="@/assets/images/close.png"
                alt=""
                class="close"
              />
            </div>
            <div class="login-btn" @click="loginTenant" v-preventReClick>
              登录
            </div>
          </div>
        </div>
        <div class="code-div" v-show="offType == 3 && !smUser.userMore">
          <!-- <img src="@/assets/images/login-img.png" alt=""> -->
          <div id="wx_box"></div>
        </div>
      </div>

      <!-- <div class="login-left">
            <div class="title">
              <img src="@/assets/images/login-logo3.png" alt="">
              <span>{{tenantInfo.briefName ? tenantInfo.briefName : tenantInfo.corpName || ''}}</span>
            </div>
            <img src="@/assets/images/login-img.png" alt="" class="thumb">
          </div> -->
      <!-- <div class="login-right">
            <div class="cont">
            </div>
          </div> -->
    </div>
    <div class="login-footer"></div>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '400px', height: '200px' }"
      @success="loginverify"
    />
    <!-- <ConfirmModal ref="modify" tip='温馨提示' :cancleOff='false' @confirm='confirmA' :content='passwordMsg'></ConfirmModal> -->
  </div>
</template>

<script>
import {
  listMyProjects,
  switchMyCurrentProject,
  cunchuUrl,
  officeUrl,
} from "@/api/project-page.js";

import { removeWatermark, setWaterMark } from "@/libs/watermark";
import { authLogin, logining } from "@/api/logins2";

import { xyycplogin } from "@/api/home-page.js";
import { getCurrentUser } from "@/api/hr-user2";
import imgA from "@/assets/images/login-logo.png";
import Verify from "@/components/verifition/Verify.vue";
// import ConfirmModal from '@/view/components/confirm-modal/confirm-modal'
import { delay } from "lodash";
export default {
  components: {
    Verify,
    // ConfirmModal
  },
  data() {
    return {
      istrue: false,
      riskLevel: null,
      offType: 1,
      // 密码
      formPwd: {
        username: "",
        tenantId: "",
        password: "",
        isLoading: true,
        time: 59,
        offCode: false,
        smsCode: "",
        captcha: "",
        smsToken: "",
      },
      rulePwd: {
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输密码",
            trigger: "blur",
          },
        ],
        smsCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      // 手机
      formPhone: {
        mobile: "",
        authCode: "",
        tenantId: "",
        single: false,
        time: 59,
        offCode: false,
        captcha: "",
      },
      rulePhone: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        authCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      timer: null,
      tenantInfo: {},
      user: {
        userMore: false, // 是否存在多个登录得用户信息
        list: [],
        item: "",
      },
      pwdUser: {
        userMore: false, // 是否存在多个登录得用户信息
        list: [],
        item: "",
      },
      smUser: {
        // 扫码
        userMore: false, // 是否存在多个登录得用户信息
        list: [],
        item: "",
      },
      lockOff: false,
      isCapsLock: true,
      imgLogo: imgA,
      isPassWord: false,
      showqrcodea: false,
      showqrcodei: false,
      passwordMsg: "",

      xyyg_login: false,
      employeeCode: "",
    };
  },
  created() {
    this.getRiskLevel();
    if (this.$route.query.ticket) {
      this.dandiandenglu();
    }
    if (this.$route.query.employeeCode) {
      this.dandiandenglu1();
    }
  },
  mounted() {
    sessionStorage.clear();
    localStorage.tagNaveList = [];
    removeWatermark();
    if (this.$route.params.list) {
      this.offType = 3;
      this.smUser.userMore = true;
      this.smUser.list = JSON.parse(this.$route.params.list);
    }
    // this.getCurrentTenant()
    this.getTenant(); // 后去租户信息
  },
  destroyed() {
    removeWatermark();
    this.formPhone.offCode = false;
    clearInterval(this.timer);
  },
  methods: {
    // 跳转忘记密码页面
    goForgetPsd() {
      let val = "1";
      this.$router.replace({
        name: "forget-psd",
        query: {
          tenantId: this.formPwd.tenantId ? this.formPwd.tenantId : "",
          val: val,
        },
      });
    },
    // 点击确定跳转修改密码页面
    confirmA() {
      this.$refs.modify.modalOff = false;
      let val = "2";
      this.$router.replace({
        name: "forget-psd",
        query: {
          tenantId: this.formPwd.tenantId ? this.formPwd.tenantId : "",
          val: val,
        },
      });
    },
    dandiandenglu() {
      logining({
        ticket: this.$route.query.ticket,
      }).then((res) => {
        const { data } = res;
        if (data.data.pwdChangeAlertCode) {
          localStorage.setItem(
            "alertPsd",
            JSON.stringify({
              alertCode: data.data.pwdChangeAlertCode,
            })
          );
        }
        this.getUserInfo();
      });
    },
    dandiandenglu1() {
      xyycplogin({
        employeeCode: this.$route.query.employeeCode,
      }).then((res) => {
        const { data } = res;
        if (data.data.pwdChangeAlertCode) {
          localStorage.setItem(
            "alertPsd",
            JSON.stringify({
              alertCode: data.data.pwdChangeAlertCode,
            })
          );
        }
        this.getUserInfo();
      });
    },
    goTenant() {
      this.$router.push({
        name: "login-tenant",
      });
    },
    mouseovera() {
      this.showqrcodea = true;
    },
    mouseleavea() {
      this.showqrcodea = false;
    },
    mouseoveri() {
      this.showqrcodei = true;
    },
    mouseleavei() {
      this.showqrcodei = false;
    },
    async changeType(val) {
      // 清空输入框校验
      this.$refs.formPhone.resetFields();
      this.$refs.formPwd.resetFields();

      this.offType = val;
      if (this.offType == 3) {
        if (this.tenantInfo.thirdType == "1") {
          await this.initWxLogin();
        } else if (this.tenantInfo.thirdType == "2") {
          await this.initDingLogin();
        }
      }
    },
    loginSubmit(event, name) {
      //
      event = event || window.event;
      if (event && event.keyCode === 13) {
        if (name == "formPwd") {
          this.loginGo(name);
        } else if (name == "formPhone") {
          this.loginPhone(name);
        }
      }
    },
    onFocus(event) {
      var bo1 = this.$refs.bo1;
      var bo2 = this.$refs.bo2;
      console.log(bo1);
      if (!this.formPwd.password) {
        bo2.style =
          "position: absolute;bottom: 0;left: 0;width: 100%;height: 2px;";
      }
      bo1.style =
        "position: absolute;bottom: 0;left: 0;width: 100%;height: 0.3rem;background: rgb(255, 255, 255);transform: width;transition:1.5s ease;";
    },
    onFocus2(event) {
      var bo1 = this.$refs.bo1;
      var bo2 = this.$refs.bo2;
      console.log(bo2);
      if (!this.formPwd.username) {
        bo1.style =
          "position: absolute;bottom: 0;left: 0;width: 100%;height: 2px;";
      }
      bo2.style =
        "position: absolute;bottom: 0;left: 0;width: 100%;height: 0.3rem;background: rgb(255, 255, 255);transform: width;transition:1.5s ease;";
    },
    onCapsLock(event, val) {
      if (
        event &&
        event.hasOwnProperty("getModifierState") &&
        event.getModifierState("CapsLock")
      ) {
        this.isCapsLock = false;
      } else {
        this.isCapsLock = true;
      }
    },
    async getRiskLevel() {
      this.riskLevel = 1;
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // 人机校验回调
    loginverify(params) {
      if (
        params &&
        [1, 2].includes(this.riskLevel) &&
        this.istrue == false &&
        this.offType == 1
      ) {
        this.formPwd.captcha = params.captchaVerification;
        authLogin(this.formPwd).then((res) => {
          const { data } = res;
          if (data.code == 0) {
            if ([1, 2, 4, 5].includes(data.data.resultCode)) {
              this.$Message.error(data.data.resultMsg);
            } else if (data.data.resultCode == 0) {
              if (data.data.pwdChangeAlertCode) {
                localStorage.setItem(
                  "alertPsd",
                  JSON.stringify({
                    alertCode: data.data.pwdChangeAlertCode,
                    alertMsg: data.data.pwdChangeAlertMsg,
                  })
                );
              }
              this.getUserInfo();
            } else if ([3, 6].includes(data.data.resultCode)) {
              this.$Message.error(data.data.resultMsg);
              this.istrue = true;
            } else if (data.data.resultCode == 7) {
              this.$Message.error(data.data.resultMsg);
              this.istrue = true;
              this.formPwd.offCode = true;
              if (data.data.smsToken == "") {
                this.$Message.error(data.data.resultMsg);
              } else {
                this.formPwd.smsToken = data.data.smsToken;
                this.timer = setInterval(() => {
                  if (this.formPwd.time < 1) {
                    this.formPwd.offCode = false;
                    clearInterval(this.timer);
                    return;
                  }
                  this.formPwd.time--;
                }, 1000);
              }
            } else if ([10, 11, 12].includes(data.data.resultCode)) {
              this.passwordMsg = data.data.resultMsg;
              this.isPassWord = true;
              this.$refs.modify.modalOff = true;
            }
          } else if (data.code == 50001) {
            // 存在多个用户信息
            this.pwdUser.userMore = true;
            this.pwdUser.list = data.data;
            clearInterval(this.timer);
          }
        });
      } else if (params && this.istrue && this.offType == 1) {
      } else if (params && this.offType == 2) {
      }
    },
    // 账号登录
    loginGo(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.riskLevel == 0) {
            authLogin(this.formPwd).then((res) => {
              const { data } = res;
              if (data.code != 0) {
                return;
              }
              if (data.code == 0 && data.data.resultCode == 0) {
                if (data.data.pwdChangeAlertCode) {
                  localStorage.setItem(
                    "alertPsd",
                    JSON.stringify({
                      alertCode: data.data.pwdChangeAlertCode,
                      alertMsg: data.data.pwdChangeAlertMsg,
                    })
                  );
                }
                this.getUserInfo();
              } else if (data.code == 50001) {
                // 存在多个用户信息
                this.pwdUser.userMore = true;
                this.pwdUser.list = data.data;
                clearInterval(this.timer);
              } else if (data.code == 0 && data.data.resultCode == 1) {
                this.$Message.error(data.data.resultMsg);
              } else if (
                data.code == 0 &&
                [10, 11, 12].includes(data.data.resultCode)
              ) {
                this.passwordMsg = data.data.resultMsg;
                this.isPassWord = true;
                this.$refs.modify.modalOff = true;
              } else {
                this.$Message.error(data.data.resultMsg);
              }
            });
          } else if (this.riskLevel == 1) {
            this.$refs.verify.show();
          } else if (this.riskLevel == 2) {
            if (this.istrue == false) {
              this.$refs.verify.show();
            } else if (this.istrue && this.formPwd.smsCode !== "") {
              authLogin(this.formPwd).then((res) => {
                const { data } = res;
                if (data.code != 0) {
                  return;
                }
                if (data.code == 0) {
                  if (data.data.resultCode == 0) {
                    if (data.data.pwdChangeAlertCode) {
                      localStorage.setItem(
                        "alertPsd",
                        JSON.stringify({
                          alertCode: data.data.pwdChangeAlertCode,
                          alertMsg: data.data.pwdChangeAlertMsg,
                        })
                      );
                    }
                    this.getUserInfo();
                  } else if ([10, 11, 12].includes(data.data.resultCode)) {
                    this.passwordMsg = data.data.resultMsg;
                    this.isPassWord = true;
                    this.$refs.modify.modalOff = true;
                  } else {
                    this.$Message.error(data.data.resultMsg);
                    this.formPwd.password = "";
                    this.formPwd.smsCode = "";
                    clearInterval(this.timer);
                  }
                } else if (data.code == 50001) {
                  // 存在多个用户信息
                  this.pwdUser.userMore = true;
                  this.pwdUser.list = data.data;
                  clearInterval(this.timer);
                } else if (data.code == 0 && data.data.resultCode == 7) {
                  this.formPwd.smsToken = data.data.smsToken;
                } else if (data.code == 0 && data.data.resultCode == 3) {
                  this.$Message.error(data.data.resultMsg);
                } else {
                  this.$Message.error(data.data.resultMsg);
                }
              });
            }
          } else if (this.riskLevel == 3) {
            if (this.istrue && this.formPwd.smsCode !== "") {
              authLogin(this.formPwd).then((res) => {
                const { data } = res;
                if (data.code == 0) {
                  if (data.data.resultCode !== 0) {
                    this.$Message.error(data.data.resultMsg);
                  } else {
                    if (data.data.pwdChangeAlertCode) {
                      localStorage.setItem(
                        "alertPsd",
                        JSON.stringify({
                          alertCode: data.data.pwdChangeAlertCode,
                          alertMsg: data.data.pwdChangeAlertMsg,
                        })
                      );
                    }
                    this.getUserInfo();
                  }
                  if ([10, 11, 12].includes(data.data.resultCode)) {
                    this.passwordMsg = data.data.resultMsg;
                    this.isPassWord = true;
                    this.$refs.modify.modalOff = true;
                  }
                } else if (data.code == 50001) {
                  // 存在多个用户信息
                  this.pwdUser.userMore = true;
                  this.pwdUser.list = data.data;
                  clearInterval(this.timer);
                }
              });
            }
          }
        }
      });
    },
    // 手机号+验证码登录
    loginPhone(name) {},
    getCode() {
      if (!this.formPhone.mobile) {
        this.$Message.error("请输入手机号");
        return;
      }
      this.$refs.verify.show();
    },
    getCodes() {
      if (!this.formPwd.username) {
        this.$Message.error("请输入账号");
        return;
      }
      this.$refs.verify.show();
    },
    getUserInfo() {
      // 用户信息
      getCurrentUser({
        loadingOff: true,
      }).then(async (res, dat) => {
        const { data } = res;
        if (data.code == 0) {
          setTimeout(() => {
            setWaterMark("", "name");
          }, 500);

          this.getCurrentTenant();
          // this.mixCommon.getMenuListByCurrentUser(data, []) // 根据用户id获取菜单-当前用户
          this.getlistMyProjects();
        }
      });
    },
    // 获取当前登录人项目
    getlistMyProjects() {
      listMyProjects({
        keyword: this.keyword,
        default: "",
      }).then((res) => {
        const { data } = res;
        if (data.data.length == 0) {
          this.$Message.error("该人员未分配项目!");
        } else if (data.data.length == 1) {
          this.switchMyCurrentProject(data.data[0].projectId);
        } else {
          this.$router.push({
            name: "project-page",
          });
        }
      });
    },
    switchMyCurrentProject(obj) {
      switchMyCurrentProject({
        projectId: obj,
      }).then((res) => {
        const { data } = res;
        if (data.code == 0) {
          this.$store.commit("set_projectData", data.data);
          getCurrentUser({
            loadingOff: true,
          }).then(async (res, dat) => {
            const { data } = res;
            if (data.code == 0) {
              this.mixCommon.getMenuListByCurrentUser(data, []); // 根据用户id获取菜单-当前用户
              this.cunchuUrl();
              this.officeUrl();
            }
          });
        }
      });
    },
    cunchuUrl() {
      cunchuUrl().then((res) => {
        const { data } = res;
        if (data.code == 0) {
          localStorage.setItem("CUNCHU_Url", "https://" + data.data + ":18081");
        }
      });
    },
    officeUrl() {
      officeUrl().then((res) => {
        const { data } = res;
        if (data.code == 0) {
          localStorage.setItem("OFFICE_Url", "https://" + data.data + ":8081");
        }
      });
    },

    getCurrentTenant() {
      // 获取当前用户得租户信息
      let tenantInfo = {
        id: 1,
        corpName: "完工管理",
        tenantType: 1,
      };
      this.$store.commit("set_tenantInfo", tenantInfo);
      // queryCurrentTenant({}).then((res, dat) => {
      //   const { data } = res
      //   if (data.code == 0) {
      //     let tenantInfo = data.data
      //     this.$store.commit('set_tenantInfo', tenantInfo)
      //   }
      // })
    },
    getTenant() {
      // 用户租户信息
      this.tenantInfo.corpName = "完工管理";
      this.tenantInfo.adminName = "";
      this.tenantInfo.adminPhone = "";
      this.tenantInfo.adminEmail = "";
      // querySingleTenantInfoByDomainByRequset({}).then((res, dat) => {
      //   const { data } = res
      //   if (data.code == 0) {
      //     this.tenantInfo = data.data
      //     this.formPhone.tenantId = this.tenantInfo.id
      //     this.formPwd.tenantId = this.tenantInfo.id
      //   }
      // })
    },
    initWxLogin() {
      let data = this.tenantInfo;
      let obj = {
        id: "wx_box", // 登录页面显示二维码的容器id
        appid: data["appId"], // 企业微信的CorpID，在企业微信管理端查看
        agentid: data["agentId"], // 授权方的网页应用id，在具体的网页应用中查看
        redirect_uri: data["redirectUrl"], // 重定向的地址，需要进行encode
        state: "200",
        // href: 'https://jugui-em.oss-cn-beijing.aliyuncs.com/qywx_qrcode.css' // 测试环境
        href: "https://juyouqi.oss-cn-beijing.aliyuncs.com/qywx_qrcode.css", // 生产环境
      };
      WwLogin(obj);
    },
    initDingLogin() {
      let data = this.tenantInfo;
      var obj = this.DDLogin({
        id: "wx_box", // 这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
        goto:
          "https://oapi.dingtalk.com/connect/qrconnect?appid=" +
          data["appId"] +
          "&response_type=code&scope=snsapi_login&state=&redirect_uri=" +
          data["redirectUrl"], // 请参考注释里的方式
        style:
          "border:none;background-color:#FFFFFF;height:20rem;width:20rem;margin-top:-2rem;",
        width: "30rem",
        height: "30rem",
      });
      var handleMessage = function (event) {
        let origin = event.origin;
        if (origin == "https://login.dingtalk.com") {
          // 判断是否来自ddLogin扫码事件。
          var loginTmpCode = event.data;
          // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          let url =
            "https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=" +
            data["appId"] +
            "&response_type=code&scope=snsapi_login&state=&redirect_uri=" +
            data["redirectUrl"] +
            "&loginTmpCode=" +
            loginTmpCode;
          location.href = url;
        }
      };
      if (typeof window.addEventListener !== "undefined") {
        window.addEventListener("message", handleMessage, false);
      } else if (typeof window.attachEvent !== "undefined") {
        window.attachEvent("onmessage", handleMessage);
      }
    },
    DDLogin(a) {
      let e = document.getElementById(a.id);
      let c = document.createElement("iframe");
      let d =
        "https://login.dingtalk.com/login/qrcode.htm?goto=" +
        encodeURIComponent(a.goto) +
        (a.style ? "&style=" + encodeURIComponent(a.style) : "") +
        (a.href ? "&href=" + a.href : "");
      c.src = d;
      c.frameBorder = "0";
      c.allowTransparency = "true";
      c.scrolling = "no";
      c.style.width = a.width ? a.width : "365px";
      c.style.height = a.height ? a.height : "400px";
      e = document.getElementById(a.id);
      e.innerHTML = "";
      e.appendChild(c);
    },
    selectItem(item) {
      if (this.offType == 1) {
        this.pwdUser.item = item;
      } else if (this.offType == 2) {
        this.user.item = item;
      } else if (this.offType == 3) {
        this.smUser.item = item;
      }
    },
    closeSm() {
      this.smUser.userMore = false;
      this.changeType(3);
    },
    closeUser() {
      this.user.userMore = false;
    },
    closePwdUser() {
      this.pwdUser.userMore = false;
    },
    // 选择租户登录
    loginTenant(name) {
      // 有两个id，一个是userId，一个是tenantId
      let datas = {};
      if (!this.pwdUser.item && this.offType == 1) {
        this.$Message.error("请选择租户信息");
        return;
      }
      if (!this.user.item && this.offType == 2) {
        this.$Message.error("请选择租户信息");
        return;
      }
      if (this.offType == 1) {
        datas = {
          userId: this.pwdUser.item.id,
          tenantId: this.pwdUser.item.tenantId,
        };
      } else if (this.offType == 2) {
        datas = {
          userId: this.user.item.id,
          tenantId: this.user.item.tenantId,
        };
      } else if (this.offType == 3) {
        datas = {
          userId: this.smUser.item.id,
          tenantId: this.smUser.item.tenantId,
        };
      }
      // loginByUserIdAndTenantId(datas).then((res) => {
      //   const { data } = res
      //   if (data.code == 0) {
      //     this.getUserInfo()
      //   }
      // })
    },
    success(params) {
      // params 返回的二次验证参数
    },
  },
};
</script>

<style lang="less">
@import "./login.less";
</style>
<template>
  <div class="login1" v-if="this.$route.query.employeeCode">加载中...</div>
  <div
    class="login"
    :style="{
      backgroundImage:
        'url(' + require('../../assets/images/login_jieyang.png') + ')',
    }"
    v-else
  >
    <div class="login-con">
      <div class="pag-cont">
        <div class="item-input" v-show="offType == 1">
          <div v-if="pwdUser.userMore">
            <div class="user-list">
              <div
                class="user-item"
                @click="selectItem(item)"
                :class="pwdUser.item.id == item.id ? 'user-item-active' : ''"
                v-for="(item, index) in pwdUser.list"
                :key="index"
              >
                <div style="flex: 1">
                  <img
                    :src="item.portraitUrl ? item.portraitUrl : imgLogo"
                    alt=""
                  />
                  <span>{{ item.tenantName }}</span>
                </div>
              </div>
              <img
                title="关闭"
                @click="closePwdUser"
                src="@/assets/images/close.png"
                alt=""
                class="close"
              />
            </div>
            <div class="login-btn" @click="loginTenant" v-preventReClick>
              登录
            </div>
          </div>
          <div v-else>
            <div
              style="
                color: rgb(87 80 80);
                text-align: center;
                margin-bottom: 8rem;
                font-weight: 600;
                font-size: 2.5rem;
                letter-spacing: 5rem;
                padding-left: 5rem;
              "
            ></div>
            <Form ref="formPwd" :model="formPwd" :rules="rulePwd">
              <FormItem prop="username">
                <Tooltip
                  content="大写锁定已打开"
                  placement="top"
                  trigger="focus"
                  :transfer="true"
                  :disabled="isCapsLock"
                >
                  <Input
                    class="input-f"
                    @keyup.enter.native="loginSubmit($event, 'formPwd')"
                    v-model="formPwd.username"
                    placeholder="请输入账号名"
                    @on-keydown="onCapsLock($event, 'user')"
                    @on-focus="onFocus($event)"
                  />
                </Tooltip>
              </FormItem>
              <FormItem prop="password">
                <Tooltip
                  content="大写锁定已打开"
                  placement="top"
                  :transfer="true"
                  :disabled="isCapsLock"
                >
                  <Input
                    class="input-f"
                    @keyup.enter.native="loginSubmit($event, 'formPwd')"
                    type="password"
                    v-model="formPwd.password"
                    placeholder="请输入密码"
                    @on-keyup="onCapsLock($event, 'pass')"
                  />
                </Tooltip>
              </FormItem>
              <FormItem prop="authCode" v-if="istrue">
                <!-- 大三大四 -->
                <div class="input-code">
                  <Input
                    class="input-f"
                    @keyup.enter.native="loginSubmit($event, 'formPwd')"
                    v-model="formPwd.smsCode"
                    placeholder="请输入短信验证码"
                  />
                  <div class="right-icon">
                    <span class="code-span" v-if="formPwd.offCode"
                      >{{ formPwd.time }}s</span
                    >
                    <span class="code-span" v-else @click="getCodes"
                      >发送验证码</span
                    >
                  </div>
                </div>
              </FormItem>
            </Form>

            <div class="login-btn" @click="loginGo('formPwd')" v-preventReClick>
              登录
            </div>

            <div class="pas-mi">
              <!-- <span style="color: rgb(87 80 80); cursor:pointer; font-weight: 600;" @click="goForgetPsd" v-if="!isPassWord">忘记密码?</span> -->
              <span
                style="color: rgb(87 80 80); cursor: pointer; font-weight: 600"
                @click="confirmA"
                v-if="isPassWord"
                >修改密码</span
              >
            </div>
          </div>
        </div>
        <div class="item-input" v-show="offType == 2">
          <div v-if="user.userMore">
            <div class="user-list">
              <div
                class="user-item"
                @click="selectItem(item)"
                :class="user.item.id == item.id ? 'user-item-active' : ''"
                v-for="(item, index) in this.user.list"
                :key="index"
              >
                <div style="flex: 1">
                  <img
                    :src="item.portraitUrl ? item.portraitUrl : imgLogo"
                    alt=""
                  />
                  <span>{{ item.tenantName }}</span>
                </div>
                <!-- <span>{{item.orgName}}</span> -->
              </div>
              <img
                title="关闭"
                @click="closeUser"
                src="@/assets/images/close.png"
                alt=""
                class="close"
              />
            </div>
            <div class="login-btn" @click="loginTenant" v-preventReClick>
              登录
            </div>
          </div>

          <div v-else>
            <Form ref="formPhone" :model="formPhone" :rules="rulePhone">
              <FormItem prop="mobile">
                <Input
                  class="input-f"
                  @keyup.enter.native="loginSubmit($event, 'formPhone')"
                  v-model="formPhone.mobile"
                  placeholder="请输入手机号"
                />
              </FormItem>
              <FormItem prop="authCode">
                <!-- 大三大四 -->
                <div class="input-code">
                  <Input
                    class="input-f"
                    @keyup.enter.native="loginSubmit($event, 'formPhone')"
                    v-model="formPhone.authCode"
                    placeholder="请输入短信验证码"
                  />
                  <div class="right-icon">
                    <span class="code-span" v-if="formPhone.offCode"
                      >{{ formPhone.time }}s</span
                    >
                    <span class="code-span" v-else @click="getCode"
                      >发送验证码</span
                    >
                  </div>
                </div>
              </FormItem>
            </Form>
            <div class="pas-mi">
              <!-- <Checkbox v-model="formPhone.single">记住密码</Checkbox> -->
              <!-- <a href="#">忘记密码?</a> -->
            </div>
            <div
              class="login-btn"
              @click="loginPhone('formPhone')"
              v-preventReClick
            >
              登录
            </div>
          </div>
          <div class="go-tentent" @click="goTenant">
            <span>还没有企业？</span><span>去注册</span>
          </div>
        </div>
        <div></div>
        <div class="item-input" v-show="offType == 3 && smUser.userMore">
          <div>
            <div class="user-list">
              <div
                class="user-item"
                @click="selectItem(item)"
                :class="smUser.item.id == item.id ? 'user-item-active' : ''"
                v-for="(item, index) in this.smUser.list"
                :key="index"
              >
                <div style="flex: 1">
                  <img
                    :src="item.portraitUrl ? item.portraitUrl : imgLogo"
                    alt=""
                  />
                  <span>{{ item.tenantName }}</span>
                </div>
                <!-- <span>{{item.orgName}}</span> -->
              </div>
              <img
                title="关闭"
                @click="closeSm"
                src="@/assets/images/close.png"
                alt=""
                class="close"
              />
            </div>
            <div class="login-btn" @click="loginTenant" v-preventReClick>
              登录
            </div>
          </div>
        </div>
        <div class="code-div" v-show="offType == 3 && !smUser.userMore">
          <!-- <img src="@/assets/images/login-img.png" alt=""> -->
          <div id="wx_box"></div>
        </div>
      </div>

      <!-- <div class="login-left">
            <div class="title">
              <img src="@/assets/images/login-logo3.png" alt="">
              <span>{{tenantInfo.briefName ? tenantInfo.briefName : tenantInfo.corpName || ''}}</span>
            </div>
            <img src="@/assets/images/login-img.png" alt="" class="thumb">
          </div> -->
      <!-- <div class="login-right">
            <div class="cont">
            </div>
          </div> -->
    </div>
    <div class="login-footer"></div>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '400px', height: '200px' }"
      @success="loginverify"
    />
    <!-- <ConfirmModal ref="modify" tip='温馨提示' :cancleOff='false' @confirm='confirmA' :content='passwordMsg'></ConfirmModal> -->
  </div>
</template>

<script>
import {
  listMyProjects,
  switchMyCurrentProject,
  cunchuUrl,
  officeUrl,
} from "@/api/project-page.js";

import { removeWatermark, setWaterMark } from "@/libs/watermark";
import { authLogin, logining } from "@/api/logins2";

import { xyycplogin } from "@/api/home-page.js";
import { getCurrentUser } from "@/api/hr-user2";
import imgA from "@/assets/images/login-logo.png";
import Verify from "@/components/verifition/Verify.vue";
// import ConfirmModal from '@/view/components/confirm-modal/confirm-modal'
import { delay } from "lodash";

export default {
  components: {
    Verify,
    // ConfirmModal
  },
  data() {
    return {
      istrue: false,
      riskLevel: null,
      offType: 1,
      // 密码
      formPwd: {
        username: "",
        tenantId: "",
        password: "",
        isLoading: true,
        time: 59,
        offCode: false,
        smsCode: "",
        captcha: "",
        smsToken: "",
      },
      rulePwd: {
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输密码",
            trigger: "blur",
          },
        ],
        smsCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      // 手机
      formPhone: {
        mobile: "",
        authCode: "",
        tenantId: "",
        single: false,
        time: 59,
        offCode: false,
        captcha: "",
      },
      rulePhone: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        authCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      timer: null,
      tenantInfo: {},
      user: {
        userMore: false, // 是否存在多个登录得用户信息
        list: [],
        item: "",
      },
      pwdUser: {
        userMore: false, // 是否存在多个登录得用户信息
        list: [],
        item: "",
      },
      smUser: {
        // 扫码
        userMore: false, // 是否存在多个登录得用户信息
        list: [],
        item: "",
      },
      lockOff: false,
      isCapsLock: true,
      imgLogo: imgA,
      isPassWord: false,
      showqrcodea: false,
      showqrcodei: false,
      passwordMsg: "",

      xyyg_login: false,
      employeeCode: "",
    };
  },
  created() {
    this.getRiskLevel();
    if (this.$route.query.ticket) {
      this.dandiandenglu();
    }
    if (this.$route.query.employeeCode) {
      this.dandiandenglu1();
    }
  },
  mounted() {
    sessionStorage.clear();
    localStorage.tagNaveList = [];
    removeWatermark();
    if (this.$route.params.list) {
      this.offType = 3;
      this.smUser.userMore = true;
      this.smUser.list = JSON.parse(this.$route.params.list);
    }
    // this.getCurrentTenant()
    this.getTenant(); // 后去租户信息
  },
  destroyed() {
    removeWatermark();
    this.formPhone.offCode = false;
    clearInterval(this.timer);
  },
  methods: {
    // 跳转忘记密码页面
    goForgetPsd() {
      let val = "1";
      this.$router.replace({
        name: "forget-psd",
        query: {
          tenantId: this.formPwd.tenantId ? this.formPwd.tenantId : "",
          val: val,
        },
      });
    },
    // 点击确定跳转修改密码页面
    confirmA() {
      this.$refs.modify.modalOff = false;
      let val = "2";
      this.$router.replace({
        name: "forget-psd",
        query: {
          tenantId: this.formPwd.tenantId ? this.formPwd.tenantId : "",
          val: val,
        },
      });
    },
    dandiandenglu() {
      logining({
        ticket: this.$route.query.ticket,
      }).then((res) => {
        const { data } = res;
        if (data.data.pwdChangeAlertCode) {
          localStorage.setItem(
            "alertPsd",
            JSON.stringify({
              alertCode: data.data.pwdChangeAlertCode,
            })
          );
        }
        this.getUserInfo();
      });
    },
    dandiandenglu1() {
      xyycplogin({
        employeeCode: this.$route.query.employeeCode,
      }).then((res) => {
        const { data } = res;
        if (data.data.pwdChangeAlertCode) {
          localStorage.setItem(
            "alertPsd",
            JSON.stringify({
              alertCode: data.data.pwdChangeAlertCode,
            })
          );
        }
        this.getUserInfo();
      });
    },
    goTenant() {
      this.$router.push({
        name: "login-tenant",
      });
    },
    mouseovera() {
      this.showqrcodea = true;
    },
    mouseleavea() {
      this.showqrcodea = false;
    },
    mouseoveri() {
      this.showqrcodei = true;
    },
    mouseleavei() {
      this.showqrcodei = false;
    },
    async changeType(val) {
      // 清空输入框校验
      this.$refs.formPhone.resetFields();
      this.$refs.formPwd.resetFields();

      this.offType = val;
      if (this.offType == 3) {
        if (this.tenantInfo.thirdType == "1") {
          await this.initWxLogin();
        } else if (this.tenantInfo.thirdType == "2") {
          await this.initDingLogin();
        }
      }
    },
    loginSubmit(event, name) {
      //
      event = event || window.event;
      if (event && event.keyCode === 13) {
        if (name == "formPwd") {
          this.loginGo(name);
        } else if (name == "formPhone") {
          this.loginPhone(name);
        }
      }
    },
    onFocus(event) {
      var bo1 = this.$refs.bo1;
      var bo2 = this.$refs.bo2;
      console.log(bo1);
      if (!this.formPwd.password) {
        bo2.style =
          "position: absolute;bottom: 0;left: 0;width: 100%;height: 2px;";
      }
      bo1.style =
        "position: absolute;bottom: 0;left: 0;width: 100%;height: 0.3rem;background: rgb(255, 255, 255);transform: width;transition:1.5s ease;";
    },
    onFocus2(event) {
      var bo1 = this.$refs.bo1;
      var bo2 = this.$refs.bo2;
      console.log(bo2);
      if (!this.formPwd.username) {
        bo1.style =
          "position: absolute;bottom: 0;left: 0;width: 100%;height: 2px;";
      }
      bo2.style =
        "position: absolute;bottom: 0;left: 0;width: 100%;height: 0.3rem;background: rgb(255, 255, 255);transform: width;transition:1.5s ease;";
    },
    onCapsLock(event, val) {
      if (
        event &&
        event.hasOwnProperty("getModifierState") &&
        event.getModifierState("CapsLock")
      ) {
        this.isCapsLock = false;
      } else {
        this.isCapsLock = true;
      }
    },
    async getRiskLevel() {
      this.riskLevel = 1;
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // 人机校验回调
    loginverify(params) {
      if (
        params &&
        [1, 2].includes(this.riskLevel) &&
        this.istrue == false &&
        this.offType == 1
      ) {
        this.formPwd.captcha = params.captchaVerification;
        authLogin(this.formPwd).then((res) => {
          const { data } = res;
          if (data.code == 0) {
            if ([1, 2, 4, 5].includes(data.data.resultCode)) {
              this.$Message.error(data.data.resultMsg);
            } else if (data.data.resultCode == 0) {
              if (data.data.pwdChangeAlertCode) {
                localStorage.setItem(
                  "alertPsd",
                  JSON.stringify({
                    alertCode: data.data.pwdChangeAlertCode,
                    alertMsg: data.data.pwdChangeAlertMsg,
                  })
                );
              }
              this.getUserInfo();
            } else if ([3, 6].includes(data.data.resultCode)) {
              this.$Message.error(data.data.resultMsg);
              this.istrue = true;
            } else if (data.data.resultCode == 7) {
              this.$Message.error(data.data.resultMsg);
              this.istrue = true;
              this.formPwd.offCode = true;
              if (data.data.smsToken == "") {
                this.$Message.error(data.data.resultMsg);
              } else {
                this.formPwd.smsToken = data.data.smsToken;
                this.timer = setInterval(() => {
                  if (this.formPwd.time < 1) {
                    this.formPwd.offCode = false;
                    clearInterval(this.timer);
                    return;
                  }
                  this.formPwd.time--;
                }, 1000);
              }
            } else if ([10, 11, 12].includes(data.data.resultCode)) {
              this.passwordMsg = data.data.resultMsg;
              this.isPassWord = true;
              this.$refs.modify.modalOff = true;
            }
          } else if (data.code == 50001) {
            // 存在多个用户信息
            this.pwdUser.userMore = true;
            this.pwdUser.list = data.data;
            clearInterval(this.timer);
          }
        });
      } else if (params && this.istrue && this.offType == 1) {
      } else if (params && this.offType == 2) {
      }
    },
    // 账号登录
    loginGo(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.riskLevel == 0) {
            authLogin(this.formPwd).then((res) => {
              const { data } = res;
              if (data.code != 0) {
                return;
              }
              if (data.code == 0 && data.data.resultCode == 0) {
                if (data.data.pwdChangeAlertCode) {
                  localStorage.setItem(
                    "alertPsd",
                    JSON.stringify({
                      alertCode: data.data.pwdChangeAlertCode,
                      alertMsg: data.data.pwdChangeAlertMsg,
                    })
                  );
                }
                this.getUserInfo();
              } else if (data.code == 50001) {
                // 存在多个用户信息
                this.pwdUser.userMore = true;
                this.pwdUser.list = data.data;
                clearInterval(this.timer);
              } else if (data.code == 0 && data.data.resultCode == 1) {
                this.$Message.error(data.data.resultMsg);
              } else if (
                data.code == 0 &&
                [10, 11, 12].includes(data.data.resultCode)
              ) {
                this.passwordMsg = data.data.resultMsg;
                this.isPassWord = true;
                this.$refs.modify.modalOff = true;
              } else {
                this.$Message.error(data.data.resultMsg);
              }
            });
          } else if (this.riskLevel == 1) {
            this.$refs.verify.show();
          } else if (this.riskLevel == 2) {
            if (this.istrue == false) {
              this.$refs.verify.show();
            } else if (this.istrue && this.formPwd.smsCode !== "") {
              authLogin(this.formPwd).then((res) => {
                const { data } = res;
                if (data.code != 0) {
                  return;
                }
                if (data.code == 0) {
                  if (data.data.resultCode == 0) {
                    if (data.data.pwdChangeAlertCode) {
                      localStorage.setItem(
                        "alertPsd",
                        JSON.stringify({
                          alertCode: data.data.pwdChangeAlertCode,
                          alertMsg: data.data.pwdChangeAlertMsg,
                        })
                      );
                    }
                    this.getUserInfo();
                  } else if ([10, 11, 12].includes(data.data.resultCode)) {
                    this.passwordMsg = data.data.resultMsg;
                    this.isPassWord = true;
                    this.$refs.modify.modalOff = true;
                  } else {
                    this.$Message.error(data.data.resultMsg);
                    this.formPwd.password = "";
                    this.formPwd.smsCode = "";
                    clearInterval(this.timer);
                  }
                } else if (data.code == 50001) {
                  // 存在多个用户信息
                  this.pwdUser.userMore = true;
                  this.pwdUser.list = data.data;
                  clearInterval(this.timer);
                } else if (data.code == 0 && data.data.resultCode == 7) {
                  this.formPwd.smsToken = data.data.smsToken;
                } else if (data.code == 0 && data.data.resultCode == 3) {
                  this.$Message.error(data.data.resultMsg);
                } else {
                  this.$Message.error(data.data.resultMsg);
                }
              });
            }
          } else if (this.riskLevel == 3) {
            if (this.istrue && this.formPwd.smsCode !== "") {
              authLogin(this.formPwd).then((res) => {
                const { data } = res;
                if (data.code == 0) {
                  if (data.data.resultCode !== 0) {
                    this.$Message.error(data.data.resultMsg);
                  } else {
                    if (data.data.pwdChangeAlertCode) {
                      localStorage.setItem(
                        "alertPsd",
                        JSON.stringify({
                          alertCode: data.data.pwdChangeAlertCode,
                          alertMsg: data.data.pwdChangeAlertMsg,
                        })
                      );
                    }
                    this.getUserInfo();
                  }
                  if ([10, 11, 12].includes(data.data.resultCode)) {
                    this.passwordMsg = data.data.resultMsg;
                    this.isPassWord = true;
                    this.$refs.modify.modalOff = true;
                  }
                } else if (data.code == 50001) {
                  // 存在多个用户信息
                  this.pwdUser.userMore = true;
                  this.pwdUser.list = data.data;
                  clearInterval(this.timer);
                }
              });
            }
          }
        }
      });
    },
    // 手机号+验证码登录
    loginPhone(name) {},
    getCode() {
      if (!this.formPhone.mobile) {
        this.$Message.error("请输入手机号");
        return;
      }
      this.$refs.verify.show();
    },
    getCodes() {
      if (!this.formPwd.username) {
        this.$Message.error("请输入账号");
        return;
      }
      this.$refs.verify.show();
    },
    getUserInfo() {
      // 用户信息
      getCurrentUser({
        loadingOff: true,
      }).then(async (res, dat) => {
        const { data } = res;
        if (data.code == 0) {
          setTimeout(() => {
            setWaterMark("", "name");
          }, 500);

          this.getCurrentTenant();
          // this.mixCommon.getMenuListByCurrentUser(data, []) // 根据用户id获取菜单-当前用户
          this.getlistMyProjects();
        }
      });
    },
    // 获取当前登录人项目
    getlistMyProjects() {
      listMyProjects({
        keyword: this.keyword,
        default: "",
      }).then((res) => {
        const { data } = res;
        if (data.data.length == 0) {
          this.$Message.error("该人员未分配项目!");
        } else if (data.data.length == 1) {
          this.switchMyCurrentProject(data.data[0].projectId);
        } else {
          this.$router.push({
            name: "project-page",
          });
        }
      });
    },
    switchMyCurrentProject(obj) {
      switchMyCurrentProject({
        projectId: obj,
      }).then((res) => {
        const { data } = res;
        if (data.code == 0) {
          this.$store.commit("set_projectData", data.data);
          getCurrentUser({
            loadingOff: true,
          }).then(async (res, dat) => {
            const { data } = res;
            if (data.code == 0) {
              this.mixCommon.getMenuListByCurrentUser(data, []); // 根据用户id获取菜单-当前用户
              this.cunchuUrl();
              this.officeUrl();
            }
          });
        }
      });
    },
    cunchuUrl() {
      cunchuUrl().then((res) => {
        const { data } = res;
        if (data.code == 0) {
          localStorage.setItem("CUNCHU_Url", "https://" + data.data + ":18081");
        }
      });
    },
    officeUrl() {
      officeUrl().then((res) => {
        const { data } = res;
        if (data.code == 0) {
          localStorage.setItem("OFFICE_Url", "https://" + data.data + ":8081");
        }
      });
    },

    getCurrentTenant() {
      // 获取当前用户得租户信息
      let tenantInfo = {
        id: 1,
        corpName: "完工管理",
        tenantType: 1,
      };
      this.$store.commit("set_tenantInfo", tenantInfo);
      // queryCurrentTenant({}).then((res, dat) => {
      //   const { data } = res
      //   if (data.code == 0) {
      //     let tenantInfo = data.data
      //     this.$store.commit('set_tenantInfo', tenantInfo)
      //   }
      // })
    },
    getTenant() {
      // 用户租户信息
      this.tenantInfo.corpName = "完工管理";
      this.tenantInfo.adminName = "";
      this.tenantInfo.adminPhone = "";
      this.tenantInfo.adminEmail = "";
      // querySingleTenantInfoByDomainByRequset({}).then((res, dat) => {
      //   const { data } = res
      //   if (data.code == 0) {
      //     this.tenantInfo = data.data
      //     this.formPhone.tenantId = this.tenantInfo.id
      //     this.formPwd.tenantId = this.tenantInfo.id
      //   }
      // })
    },
    initWxLogin() {
      let data = this.tenantInfo;
      let obj = {
        id: "wx_box", // 登录页面显示二维码的容器id
        appid: data["appId"], // 企业微信的CorpID，在企业微信管理端查看
        agentid: data["agentId"], // 授权方的网页应用id，在具体的网页应用中查看
        redirect_uri: data["redirectUrl"], // 重定向的地址，需要进行encode
        state: "200",
        // href: 'https://jugui-em.oss-cn-beijing.aliyuncs.com/qywx_qrcode.css' // 测试环境
        href: "https://juyouqi.oss-cn-beijing.aliyuncs.com/qywx_qrcode.css", // 生产环境
      };
      WwLogin(obj);
    },
    initDingLogin() {
      let data = this.tenantInfo;
      var obj = this.DDLogin({
        id: "wx_box", // 这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
        goto:
          "https://oapi.dingtalk.com/connect/qrconnect?appid=" +
          data["appId"] +
          "&response_type=code&scope=snsapi_login&state=&redirect_uri=" +
          data["redirectUrl"], // 请参考注释里的方式
        style:
          "border:none;background-color:#FFFFFF;height:20rem;width:20rem;margin-top:-2rem;",
        width: "30rem",
        height: "30rem",
      });
      var handleMessage = function (event) {
        let origin = event.origin;
        if (origin == "https://login.dingtalk.com") {
          // 判断是否来自ddLogin扫码事件。
          var loginTmpCode = event.data;
          // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          let url =
            "https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=" +
            data["appId"] +
            "&response_type=code&scope=snsapi_login&state=&redirect_uri=" +
            data["redirectUrl"] +
            "&loginTmpCode=" +
            loginTmpCode;
          location.href = url;
        }
      };
      if (typeof window.addEventListener !== "undefined") {
        window.addEventListener("message", handleMessage, false);
      } else if (typeof window.attachEvent !== "undefined") {
        window.attachEvent("onmessage", handleMessage);
      }
    },
    DDLogin(a) {
      let e = document.getElementById(a.id);
      let c = document.createElement("iframe");
      let d =
        "https://login.dingtalk.com/login/qrcode.htm?goto=" +
        encodeURIComponent(a.goto) +
        (a.style ? "&style=" + encodeURIComponent(a.style) : "") +
        (a.href ? "&href=" + a.href : "");
      c.src = d;
      c.frameBorder = "0";
      c.allowTransparency = "true";
      c.scrolling = "no";
      c.style.width = a.width ? a.width : "365px";
      c.style.height = a.height ? a.height : "400px";
      e = document.getElementById(a.id);
      e.innerHTML = "";
      e.appendChild(c);
    },
    selectItem(item) {
      if (this.offType == 1) {
        this.pwdUser.item = item;
      } else if (this.offType == 2) {
        this.user.item = item;
      } else if (this.offType == 3) {
        this.smUser.item = item;
      }
    },
    closeSm() {
      this.smUser.userMore = false;
      this.changeType(3);
    },
    closeUser() {
      this.user.userMore = false;
    },
    closePwdUser() {
      this.pwdUser.userMore = false;
    },
    // 选择租户登录
    loginTenant(name) {
      // 有两个id，一个是userId，一个是tenantId
      let datas = {};
      if (!this.pwdUser.item && this.offType == 1) {
        this.$Message.error("请选择租户信息");
        return;
      }
      if (!this.user.item && this.offType == 2) {
        this.$Message.error("请选择租户信息");
        return;
      }
      if (this.offType == 1) {
        datas = {
          userId: this.pwdUser.item.id,
          tenantId: this.pwdUser.item.tenantId,
        };
      } else if (this.offType == 2) {
        datas = {
          userId: this.user.item.id,
          tenantId: this.user.item.tenantId,
        };
      } else if (this.offType == 3) {
        datas = {
          userId: this.smUser.item.id,
          tenantId: this.smUser.item.tenantId,
        };
      }
      // loginByUserIdAndTenantId(datas).then((res) => {
      //   const { data } = res
      //   if (data.code == 0) {
      //     this.getUserInfo()
      //   }
      // })
    },
    success(params) {
      // params 返回的二次验证参数
    },
  },
};
</script>

<style lang="less" scope>
.code-span {
  cursor: pointer;
  font-size: 12px;
}

.input-code {
  // border: 1px solid red;
  position: relative;

  .right-icon {
    position: absolute;
    right: 1rem;
    top: 0;
  }
}

#wx_box {
  width: 35rem;
  // height: 30rem;
  height: 100%;
  min-height: 30rem;
  margin: 0 auto;
  // padding-top: 2rem !important;
  // margin-left: 2rem;
  // border: 1px solid red;
}

#wx_box iframe {
  width: 35rem;
  height: 100%;

  .impowerBox .qrcode {
    width: 12rem;
  }
}

.user-list {
  position: relative;
  overflow-y: auto;
  max-height: 20rem;
  margin-top: 5rem;

  span {
    font-size: 1.2rem;
  }

  .close {
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
    width: 2.5rem;
    height: 2.5rem;
    z-index: 1;
    cursor: pointer;
  }

  .user-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0.5rem 0px;
    // font-size: 1.4rem;
    padding: 0.5rem 0px;
    cursor: pointer;

    div:nth-of-type(1) {
      display: flex;
      align-items: center;

      img {
        width: 4rem;
        height: 4rem;
        border-radius: 100%;
        margin-right: 1rem;
      }
    }
  }

  .user-item-active {
    color: #0858e3;
  }
}

.bottom-text {
  text-align: center;
  padding: 1rem 0px;
  font-size: 1.2rem;
  color: #aaa;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;

  a {
    color: #aaa;
    cursor: pointer;
  }

  a:hover {
    color: #3d81f7;
  }
}
</style>